import { IsWebFn, IsMobileFn } from './interface';

export const isWeb: IsWebFn = () => true;
export const isMobile: IsMobileFn = () => false;
